import React from 'react';
import { Mail, Phone, MapPin, Send } from 'lucide-react';

const Contact = () => {
  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    // Handle form submission
  };

  return (
    <div className="bg-gray-50 min-h-screen py-12">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-12">
          <h1 className="text-4xl font-bold mb-4">Contact Us</h1>
          <p className="text-gray-600">
            Have questions? We'd love to hear from you. Send us a message and we'll respond as soon as possible.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-12">
          {/* Contact Information */}
          <div className="bg-white rounded-lg shadow-md p-8">
            <h2 className="text-2xl font-semibold mb-6">Get in Touch</h2>
            
            {/* India Contact */}
            <div className="mb-8">
              <h3 className="text-lg font-medium mb-4">India Office</h3>
              <div className="space-y-6">
                <div className="flex items-start">
                  <div className="flex-shrink-0">
                    <Phone className="h-6 w-6 text-yellow-500" />
                  </div>
                  <div className="ml-4">
                    <h4 className="text-base font-medium">Phone</h4>
                    <p className="text-gray-600">+91-9550729943</p>
                    <p className="text-gray-600">Monday - Saturday, 9am - 6pm IST</p>
                  </div>
                </div>

                <div className="flex items-start">
                  <div className="flex-shrink-0">
                    <MapPin className="h-6 w-6 text-yellow-500" />
                  </div>
                  <div className="ml-4">
                    <h4 className="text-base font-medium">Address</h4>
                    <p className="text-gray-600">
                      Ramavarappadu ring road,<br />
                      Vijayawada, Andhra Pradesh 520004,<br />
                      India
                    </p>
                  </div>
                </div>
              </div>
            </div>

            {/* Canada Contact */}
            <div className="pt-8 border-t">
              <h3 className="text-lg font-medium mb-4">Canada Office</h3>
              <div className="space-y-6">
                <div className="flex items-start">
                  <div className="flex-shrink-0">
                    <Phone className="h-6 w-6 text-yellow-500" />
                  </div>
                  <div className="ml-4">
                    <h4 className="text-base font-medium">Phone</h4>
                    <p className="text-gray-600">+1-418-518-0785</p>
                    <p className="text-gray-600">Monday - Friday, 9am - 5pm EST</p>
                  </div>
                </div>

                <div className="flex items-start">
                  <div className="flex-shrink-0">
                    <MapPin className="h-6 w-6 text-yellow-500" />
                  </div>
                  <div className="ml-4">
                    <h4 className="text-base font-medium">Address</h4>
                    <p className="text-gray-600">
                      5801 Rue Alian,<br />
                      Brossard, Quebec J4Z 1H3,<br />
                      Canada
                    </p>
                  </div>
                </div>
              </div>
            </div>

            {/* Email - Common for both */}
            <div className="mt-6 pt-6 border-t">
              <div className="flex items-start">
                <div className="flex-shrink-0">
                  <Mail className="h-6 w-6 text-yellow-500" />
                </div>
                <div className="ml-4">
                  <h4 className="text-base font-medium">Email</h4>
                  <p className="text-gray-600">orders@manamamidipallu.com</p>
                  <p className="text-gray-600">support@manamamidipallu.com</p>
                </div>
              </div>
            </div>
          </div>

          {/* Contact Form */}
          <div className="bg-white rounded-lg shadow-md p-8">
            <h2 className="text-2xl font-semibold mb-6">Send us a Message</h2>
            <form onSubmit={handleSubmit} className="space-y-6">
              <div>
                <label htmlFor="name" className="block text-sm font-medium text-gray-700">
                  Name
                </label>
                <input
                  type="text"
                  id="name"
                  name="name"
                  className="mt-1 block w-full rounded-md border-gray-300 shadow-sm focus:border-yellow-500 focus:ring-yellow-500"
                  required
                />
              </div>

              <div>
                <label htmlFor="email" className="block text-sm font-medium text-gray-700">
                  Email
                </label>
                <input
                  type="email"
                  id="email"
                  name="email"
                  className="mt-1 block w-full rounded-md border-gray-300 shadow-sm focus:border-yellow-500 focus:ring-yellow-500"
                  required
                />
              </div>

              <div>
                <label htmlFor="subject" className="block text-sm font-medium text-gray-700">
                  Subject
                </label>
                <input
                  type="text"
                  id="subject"
                  name="subject"
                  className="mt-1 block w-full rounded-md border-gray-300 shadow-sm focus:border-yellow-500 focus:ring-yellow-500"
                  required
                />
              </div>

              <div>
                <label htmlFor="message" className="block text-sm font-medium text-gray-700">
                  Message
                </label>
                <textarea
                  id="message"
                  name="message"
                  rows={4}
                  className="mt-1 block w-full rounded-md border-gray-300 shadow-sm focus:border-yellow-500 focus:ring-yellow-500"
                  required
                ></textarea>
              </div>

              <button
                type="submit"
                className="w-full bg-yellow-500 text-white px-6 py-3 rounded-lg hover:bg-yellow-600 transition-colors flex items-center justify-center"
              >
                <Send className="h-5 w-5 mr-2" />
                Send Message
              </button>
            </form>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Contact;